import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import useLinkProps from '../../../../../hooks/use-link-props';
import BackgroundLink from '../../../../ui/links/background';
import Carousel from '../../../../ui/v2/carousel';
import ImageLabel from '../../../../ui/v2/products/image-label';

const LastVehicles: FunctionComponent<{
  products: Array<TVehicleCard>;
  vehicle?: TCarInfo;
}> = ({ products, vehicle }) => {
  const { t } = useTranslation();
  const getLink = useLinkProps();

  return (
    <section className={cx('bg-neutral-10', 'pt-12', 'pb-[42px]')}>
      <span
        className={cx(
          'container mx-auto',
          'block',
          'max-lg:px-8',
          'font-bold',
          'text-[22px]',
          'lg:text-[32px]',
          'text-center',
          'mb-6'
        )}
      >
        {t('vehicle:last-vehicles', {
          vehicle: `${vehicle?.brand?.name || ''} ${
            vehicle?.model?.name || ''
          }`,
        })}
      </span>

      <div className="container m-auto">
        <Carousel
          perPage={4}
          items={products.map((product) => ({
            value: (
              <BackgroundLink
                variant="DEFAULT"
                {...getLink('vehicle', {
                  vehicle: product.slug,
                })}
              >
                <ImageLabel
                  product={product}
                  isVehicle
                  altImage={'common:images_alt.last_vehicles_alt'}
                />
              </BackgroundLink>
            ),
            key: product.id.toString(),
          }))}
        />
      </div>
    </section>
  );
};

export default LastVehicles;
